var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.375 4.375H5.625C4.93359 4.375 4.375 4.93359 4.375 5.625V34.375C4.375 35.0664 4.93359 35.625 5.625 35.625H34.375C35.0664 35.625 35.625 35.0664 35.625 34.375V5.625C35.625 4.93359 35.0664 4.375 34.375 4.375ZM30.7656 13.4961H28.2695C26.3125 13.4961 25.9336 14.4258 25.9336 15.793V18.8047H30.6055L29.9961 23.5195H25.9336V35.625H21.0625V23.5234H16.9883V18.8047H21.0625V15.3281C21.0625 11.293 23.5273 9.09375 27.1289 9.09375C28.8555 9.09375 30.3359 9.22266 30.7695 9.28125V13.4961H30.7656Z",
    fill: "#666969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.7b6f17529fa16a938004992079a05cb8.svg";
export { ForwardRef as ReactComponent };